import { render, staticRenderFns } from "./CardPropertiesCompare.vue?vue&type=template&id=1cb2b348"
import script from "./CardPropertiesCompare.vue?vue&type=script&lang=js"
export * from "./CardPropertiesCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports